export const RedAsterisk = () => {
  return <span style={{ color: '#EB5757', margin: '0 2px' }}>*</span>;
};
